var WDN = WDN || {};

if (typeof WDN.Overlay === "undefined") {
  WDN.Overlay = (function () {
    /* DRAWER/MODAL */
    class WDNOverlay extends HTMLElement {
      constructor() {
        super();

        // Config
        this.config = {
          classes: {
            body_open: "overlay--open",
            open_vertical: "overlay--open-vertical",
            open_horizonal: "overlay--open-horizontal",
          },
          version: "1.1",
        };

        // Storing attributes
        this.id = this.getAttribute("data-id");
        this.isActive = this.getAttribute("data-active") == "";
        this.animate = this.getAttribute("data-animate");
        this.inner_div = this.querySelector("div");
        this.overlaySpecificClass =
          this.config.classes.body_open + "-" + this.id;
        // Getting and storing type of the overlay (drawer,modal etc)
        var type = this.getAttribute("type") || "overlay";
        this.type = type;
        // setup of custom events names
        this.events = {
          open: type + ":opened",
          close: type + ":closed",
        };

        this.ignoreFade = this.getAttribute("data-ignore-fade") == "";

        // Event Callbacks
        this.closeOnKeyBound = this.closeOnKey.bind(this);
        this.closeOnClickBound = this.closeOnClick.bind(this);

        // INIT
        this.init();
      }

      fireEvent(data) {
        var target = data.target || document.body;
        target.dispatchEvent(
          new CustomEvent(data.name, { detail: data.detail })
        );
      }

      active(newState) {
        if (newState) {
          this.setAttribute("data-active", "");
        } else {
          this.removeAttribute("data-active");
        }
        this.isActive = newState;
      }

      resetScrollPosition() {
        this.inner_div.scroll(0, 0);
      }

      setActive() {
        this.resetScrollPosition();
        this.active(true);
        this.appendActiveClasses();
      }

      setInactive() {
        this.active(false);
        this.removeActiveClasses();
      }

      open() {
        this.fireEvent({
          name: "overlay:close",
          target: document.body,
          detail: this,
        });
        // setting element as active
        this.setActive();
        // Bind window events
        this.bindWindowEvents();
        // fire custom event
        this.fireEvent({
          name: this.events.open,
          detail: this,
        });

        typeof this.onOpen === "function" ? this.onOpen() : false;
      }

      close() {
        this.setInactive();
        this.unbindWindowEvents();

        this.fireEvent({
          name: this.events.close,
          detail: this,
        });
        typeof this.onOpen === "function" ? this.onClose() : false;
      }

      closeOnKey(e) {
        if (e.keyCode == 27) {
          this.close();
        }
      }

      closeOnClick(e) {
        if (
          e.target === document.body ||
          (e.target === this && (this.nodeName === "WDN-MODAL" || this.nodeName === "MO-DAL"))
        ) {
          this.close();
        }
      }

      bindWindowEvents() {
        window.addEventListener("keydown", this.closeOnKeyBound);
        window.addEventListener("click", this.closeOnClickBound);
      }

      unbindWindowEvents() {
        window.removeEventListener("keydown", this.closeOnKeyBound);
        window.removeEventListener("click", this.closeOnClickBound);
      }

      appendActiveClasses() {
        this.classList.add(this.currentAnimation);
        document.body.classList.add(
          this.config.classes.body_open,
          this.overlaySpecificClass
        );
      }

      removeActiveClasses() {
        this.classList.remove(this.currentAnimation);
        document.body.classList.remove(
          this.config.classes.body_open,
          this.overlaySpecificClass
        );
        if (!this.ignoreFade) {
          document.body.classList.add("overlay--open-fade-out");
          setTimeout(function () {
            document.body.classList.remove("overlay--open-fade-out");
          }, 200);
        }
      }

      setupAnimation() {
        this.currentAnimation = this.config.classes.open_horizonal;
        if (this.animate === "top" || this.animate === "bottom") {
          this.currentAnimation = this.config.classes.open_vertical;
        }
      }

      onCloseEvent(e) {
        if (this.isActive) {
          var default_fade = this.ignoreFade;
          this.ignoreFade = true;
          this.close();
          this.ignoreFade = default_fade;
        }
      }

      onOpenEvent(e) {
        if (!e.detail || e.detail.id != this.id || this.isActive) return;
        this.open();
      }

      listenForEvents() {
        document.body.addEventListener(
          "overlay:close",
          this.onCloseEvent.bind(this)
        );
        document.body.addEventListener(
          "overlay:open",
          this.onOpenEvent.bind(this)
        );
      }

      init() {
        this.listenForEvents();
        this.setupAnimation();
      }
    }

    class WDNOverlayTrigger extends HTMLElement {
      constructor() {
        super();
        // drawer/modal id
        this.id = this.getAttribute("data-id");
        // actions - open, close
        this.action = this.getAttribute("action");
        // type can be modal, drawer etc
        this.type = this.getAttribute("type");
        // drawer/modal
        this.element = document.querySelector(
          "wdn-" + this.type + "[data-id='" + this.id + "']"
        );

        // INIT
        this.bind();
      }

      fireEvent(data) {
        var target = data.target || document.body;
        target.dispatchEvent(
          new CustomEvent(data.name, { detail: data.detail })
        );
      }

      handleClick() {
        if (this.element.isActive) {
          this.element.close();
          this.removeAttribute("data-active");
        } else {
          this.element.open();
          this.setAttribute("data-active", "");
        }
      }

      onCloseEvent(e) {
        if (e.detail.id !== this.id) return;
        this.removeAttribute("data-active");
      }

      onOpenEvent(e) {
        if (e.detail.id !== this.id) return;
        this.setAttribute("data-active", "");
      }

      bind() {
        if (this.element) {
          this.addEventListener("click", this.handleClick.bind(this));
          document.body.addEventListener(
            "overlay:closed",
            this.onCloseEvent.bind(this)
          );
          document.body.addEventListener(
            "overlay:opened",
            this.onOpenEvent.bind(this)
          );
        }
      }
    }

    /* DRAWER CLOSER */
    class WDNDrawerClose extends WDNOverlayTrigger {
      constructor() {
        super();
        this.element = document.querySelector(
          "wdn-drawer[data-id='" + this.id + "']"
        );
        this.action = "close";
        this.bind();
      }
    }
    customElements.define("wdn-drawer-close", WDNDrawerClose);

    /* MODAL CLOSER */
    if (!customElements.get("wdn-modal-close")) {
      class WDNModalClose extends WDNOverlayTrigger {
        constructor() {
          super();
          this.element = document.querySelector(
            "wdn-modal[data-id='" + this.id + "']"
          );
          this.action = "close";
          this.bind();
        }
      }
      customElements.define("wdn-modal-close", WDNModalClose);
    }

    /* DRAWER OPENER */
    if (!customElements.get("wdn-drawer-open")) {
      class WDNDrawerOpen extends WDNOverlayTrigger {
        constructor() {
          super();
          this.element = document.querySelector(
            "wdn-drawer[data-id='" + this.id + "']"
          );
          this.action = "open";
          this.bind();
        }
      }
      customElements.define("wdn-drawer-open", WDNDrawerOpen);
    }

    // MODAL OPENER
    if (!customElements.get("wdn-modal-open")) {
      class WDNModalOpen extends WDNOverlayTrigger {
        constructor() {
          super();
          this.element = document.querySelector(
            "wdn-modal[data-id='" + this.id + "']"
          );
          this.action = "open";
          this.bind();
        }
      }
      customElements.define("wdn-modal-open", WDNModalOpen);
    }

    // DRAWER
    if (!customElements.get("wdn-drawer")) {
      customElements.define("wdn-drawer", class extends WDNOverlay {});
    }

    // MODAL
    if (!customElements.get("wdn-modal")) {
      class WDNModal extends WDNOverlay {
        constructor() {
          super();
          this.config.classes.body_open = "overlay--open";
        }
      }
      customElements.define("wdn-modal", WDNModal);
    }

    // MODAL
    if (!customElements.get("mo-dal")) {
      class CModal extends WDNOverlay {
        constructor() {
          super();
          this.config.classes.body_open = "mo-dal--open";
        }

        open() {
          this.setActive();
          this.bindWindowEvents();

          typeof this.onOpen === "function" ? this.onOpen() : false;
        }

        close() {
          this.setInactive();
          this.unbindWindowEvents();
          typeof this.onOpen === "function" ? this.onClose() : false;
        }

        init() {
          this.setupAnimation();
        }
      }

      customElements.define("mo-dal", CModal);
    }

    return WDNOverlay;
  })();
}
